import { render, staticRenderFns } from "./VehiculesListFilters.vue?vue&type=template&id=2b2d0920&"
import script from "./VehiculesListFilters.vue?vue&type=script&lang=js&"
export * from "./VehiculesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./VehiculesListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports